// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__CUbZe","requiredAsterisk":"Info_requiredAsterisk__1AbfD"};